import { render } from "./EcommerceProcessor.vue?vue&type=template&id=51b2a296"
import script from "./EcommerceProcessor.vue?vue&type=script&lang=js"
export * from "./EcommerceProcessor.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.14.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__